import "./dashboard.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../utils/api";

export default function Dashboard() {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    totalVideos: 0,
    totalShorts: 0,
    totalPosts: 0,
    totalSongs: 0,
    videoViews: 0,
    shortsViews: 0,
    postViews: 0,
    songViews: 0,
    totalViews: 0,
    totalEarnings: 0,
  });

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const channelId = user?.channelId;
  const userId = user?._id;

  useEffect(() => {
    if (!channelId || !userId) return;

    const fetchDashboardData = async () => {
      try {
        /* ================= VIDEOS & SHORTS ================= */
        const channelRes = await api.get("/client/user/detailsOfChannel", {
          params: { channelId, userId, start: 1, limit: 500 },
        });

        if (!channelRes.data.status) return;

        const allVideos = channelRes.data.detailsOfChannel || [];

        const onlyVideos = allVideos.filter(v => v.videoType === 1);
        const onlyShorts = allVideos.filter(v => v.videoType === 2);

        const videoViews = onlyVideos.reduce(
          (sum, v) => sum + (v.views || 0),
          0
        );

        const shortsViews = onlyShorts.reduce(
          (sum, v) => sum + (v.views || 0),
          0
        );

        /* ================= POSTS ================= */
        const postRes = await api.get("/client/posts/channel-posts", {
          params: { channelId },
        });

        const posts =
          postRes?.data?.status
            ? postRes.data.postsOfChannel || []
            : [];

        const postViews = posts.reduce(
          (sum, p) => sum + (p.viewsCount || 0),
          0
        );

        /* ================= SONGS ================= */
        const songRes = await api.get("/client/song/songsOfChannel", {
          params: { channelId },
        });

        const songs =
          songRes?.data?.status
            ? songRes.data.songs || []
            : [];

        const songViews = songs.reduce(
          (sum, s) => sum + (s.totalPlays || 0),
          0
        );

        /* ================= EARNINGS ================= */
        const profileRes = await api.get("/client/user/profile", {
          params: { userId },
        });

        let totalEarnings = 0;

        if (profileRes.data.status) {
          totalEarnings =
            Number(profileRes.data.user?.totalEarningAmount) || 0;
        }

        /* ================= TOTAL ================= */
        const totalViews =
          videoViews +
          shortsViews +
          postViews +
          songViews;

        setStats({
          totalVideos: onlyVideos.length,
          totalShorts: onlyShorts.length,
          totalPosts: posts.length,
          totalSongs: songs.length,
          videoViews,
          shortsViews,
          postViews,
          songViews,
          totalViews,
          totalEarnings,
        });

      } catch (err) {
        console.error("Dashboard load error:", err);
      }
    };

    fetchDashboardData();
  }, [channelId, userId]);

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";
    return num;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const handleViewChannel = () => {
    if (!userId) {
      localStorage.clear();
      navigate("/login");
      return;
    }

    if (!channelId) {
      alert("Channel not created yet");
      return;
    }

    navigate(`/user/channel/${channelId}`);
  };

  return (
    <div className="dashboard">
      <h1 className="dashboard-title">Dashboard</h1>

      <div className="stats-grid">

        <div className="stat-card">
          <h3>Total Videos</h3>
          <p className="stat-number">{stats.totalVideos}</p>
        </div>

        <div className="stat-card">
          <h3>Total Shorts</h3>
          <p className="stat-number">{stats.totalShorts}</p>
        </div>

        <div className="stat-card">
          <h3>Total Posts</h3>
          <p className="stat-number">{stats.totalPosts}</p>
        </div>

        <div className="stat-card">
          <h3>Total Songs</h3>
          <p className="stat-number">{stats.totalSongs}</p>
        </div>

        <div className="stat-card">
          <h3>Total Views</h3>
          <p className="stat-number">{formatNumber(stats.totalViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Video Views</h3>
          <p className="stat-number">{formatNumber(stats.videoViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Shorts Views</h3>
          <p className="stat-number">{formatNumber(stats.shortsViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Post Views</h3>
          <p className="stat-number">{formatNumber(stats.postViews)}</p>
        </div>

        <div className="stat-card">
          <h3>Song Plays</h3>
          <p className="stat-number">{formatNumber(stats.songViews)}</p>
        </div>

        <div className="stat-card earnings-card">
          <h3>Total Earnings</h3>
          <p className="stat-number">
            {formatCurrency(stats.totalEarnings)}
          </p>
        </div>

      </div>

      <div className="creator-studio-section">
        <h2 className="section-title">Creator Studio</h2>

        <div className="quick-actions">
          <button onClick={() => navigate("/user/upload-video")}>
            Create Video
          </button>

          <button onClick={() => navigate("/user/upload-short")}>
            Create Short
          </button>


         <button onClick={() => navigate("/user/upload-song")}>
           Create Song
         </button>

          <button onClick={handleViewChannel}>
            View My Channel
          </button>
        </div>
      </div>

    </div>
  );
}